// extracted by mini-css-extract-plugin
export var container = "_5t-0";
export var error = "_5t-9";
export var label = "_5t-5";
export var light = "_5t-6";
export var md = "_5t-3";
export var sm = "_5t-2";
export var thin = "_5t-8";
export var thinBold = "_5t-7";
export var vertical = "_5t-4";
export var xs = "_5t-1";